import { getGuidFromHref, OwnerReference, ownerReferenceService, useBeforeunload, useLoading } from '@sd/shared';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';

type Props = {
  unitGuid: string;
};

export const Notes = (props: Props) => {
  const [sellerNotes, setSellerNotes] = useState('');
  const [previousOwnerReference, setPreviousOwnerReference] = useState<OwnerReference>();
  const [lastUpdated, setLastUpdated] = useState<Date>();
  const { useLoadingEffect } = useLoading();

  useLoadingEffect(async () => {
    const existingOwnerReference = (await ownerReferenceService.getByUnit(props.unitGuid))[0];
    const previousNotes = existingOwnerReference?.notes || '';
    setSellerNotes(previousNotes);
    setPreviousOwnerReference(existingOwnerReference);
    if (existingOwnerReference?.updatedOn) {
      setLastUpdated(new Date(existingOwnerReference.updatedOn));
    }
  }, []);

  useBeforeunload(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    handleSaveSellerNotes();
  });

  const handleSaveSellerNotes = async () => {
    const trimmedSellerNotes = sellerNotes.trim();
    if (trimmedSellerNotes !== previousOwnerReference?.notes) {
      setSellerNotes(trimmedSellerNotes);
      if (previousOwnerReference) {
        await ownerReferenceService.update(previousOwnerReference.id, trimmedSellerNotes);
        setPreviousOwnerReference({ ...previousOwnerReference, notes: trimmedSellerNotes });
      } else {
        const newOwnerReferenceHref = await ownerReferenceService.create(props.unitGuid, trimmedSellerNotes);
        setPreviousOwnerReference({
          id: getGuidFromHref(newOwnerReferenceHref),
          notes: trimmedSellerNotes,
          href: newOwnerReferenceHref
        });
      }
      setLastUpdated(new Date());
    }
  };

  return (
    <div>
      <NotesTextArea
        data-testid="seller-notes-field"
        value={sellerNotes}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setSellerNotes(event.target.value);
        }}
        onBlur={() => handleSaveSellerNotes()}
      />
      {lastUpdated && <p>Notes Last Saved {lastUpdated.toLocaleString()}</p>}
      <p className="text-sm text-muted text-center">These notes will not appear in OVE</p>
    </div>
  );
};

const NotesTextArea = styled(Form.Control).attrs({ as: 'textarea' })`
  display: flex;
  min-height: 200px;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.spacer2};
`;
